/**
 * Toast / notification handlers for Complete → Reopen VQQ success/error.
 * Shared by My VQQs action menu (and any grid using the same toast pattern).
 */
export function createReopenVqqFeedbackHandlers({
  rfiActionToast,
  setLocalNotificationError,
  setShowNotification,
  setMessage,
  refetch,
}) {
  return {
    onSuccess: () => {
      if (rfiActionToast) {
        rfiActionToast.showToast({
          message: "VQQ reopened successfully",
          status: "success",
        });
      } else {
        setLocalNotificationError?.(false);
        setShowNotification?.(true);
        setMessage?.("VQQ reopened successfully");
      }
      refetch?.();
    },
    onError: (err) => {
      setLocalNotificationError?.(true);
      setShowNotification?.(true);
      setMessage?.(err?.response?.data?.message || "Error reopening VQQ");
    },
  };
}
